export const clientDeleteSuccess = "Utilisateur supprimé avec succès";
export const clientDeleteFailed = "Échec de la suppression de l'utilisateur";

export const emailPasswordRecoveredSucess = "E-mail de récupération envoyé avec succès";
export const emailPasswordRecoveredFailed = "Échec de l'envoi de l'e-mail de récupération";

export const clientCreationSuccess = "Utilisateur créé avec succès";
export const clientCreationFailed = "Échec lors de la création de l'utilisateur";
